import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import Customer from "../../../containers/modules/master/customer";

export default function CustomerRoute( props ) {
    const {authUser}=props
    return (
        <Route
            path="customer"
            index
            element={
                <AccessControl
                name={"Customer List"}
                auth={authUser}
                component={()=><Customer authUser={authUser} />}
                />
            }
        />
    )
}